exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-item {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-top: 10px;\n}\n.search-item > label {\n  margin: 0;\n  margin-right: 5px;\n}\n.box-position {\n  float: left;\n  margin-left: 20px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/activity/settingCourse.component.css
// module id = ../../../../../src/app/activity/settingCourse.component.css
// module chunks = main